import { z } from "zod";

import { US_STATES } from "@/constants/states";

/**
 * The rules over the address every place form collects — the schema twin of
 * `PlaceAddressFormValues`. One home: the ZIP regex and the "is that a real state" check
 * must not drift between the member add-place step and the presale funnel. Coordinates
 * are not here; only the forms that carry them extend this.
 */
export const placeAddressSchema = z.object({
  streetAddress: z.string().trim().min(1, "Street address is required"),
  streetAddressLine2: z.string().trim(),
  city: z.string().trim().min(1, "City / town is required"),
  state: z
    .string()
    .trim()
    .min(1, "State is required")
    .refine((val) => US_STATES.some((s) => s.code === val), {
      message: "Select a valid state",
    }),
  zip: z
    .string()
    .trim()
    .min(1, "ZIP code is required")
    .regex(
      /^\d{5}(?:-\d{4})?$/,
      "Enter a valid ZIP (e.g., 02118 or 02118-1234)",
    ),
});
